<template>
  <div v-if="visible" class="sf" style="left: 20px; bottom: 20px">
    <transition name="sf-pop">
      <div v-if="open" class="sf-panel card" role="dialog" aria-label="الدعم الفني" style="left: 0">
        <div class="sf-head">
          <div class="sf-head-icon"><i class="fa fa-headphones"></i></div>
          <div class="sf-head-text">
            <strong>الدعم الفني</strong>
            <small>المساعد الذكي يجيبك فوراً</small>
          </div>
          <button type="button" class="sf-x" aria-label="إغلاق" @click="open = false"><i class="fa fa-times"></i></button>
        </div>
        <div class="sf-links">
          <!-- a school the support team stopped from urgent tickets gets «تذكرة دعم فني» instead -->
          <button v-if="supportState == 'blocked'" type="button" class="sf-link" @click="go('/feedback?open=normal')">
            <i class="fa fa-life-ring"></i> تذكرة دعم فني
          </button>
          <button v-else type="button" class="sf-link sf-link-urgent" @click="go('/feedback?open=urgent')">
            <i class="fa fa-bolt"></i> الدعم الفني السريع
          </button>
          <a class="sf-link sf-link-wa" :href="whatsapp" target="_blank" rel="noopener">
            <i class="fa fa-whatsapp"></i> واتساب
          </a>
          <button type="button" class="sf-link" @click="go('/feedback')">
            <i class="fa fa-ticket"></i> تذاكري
          </button>
        </div>
        <div class="sf-bot">
          <support-bot compact @urgent="urgent" />
        </div>
      </div>
    </transition>
    <button type="button" class="sf-fab" :class="{ 'sf-fab-open': open }" :aria-expanded="open ? 'true' : 'false'"
            aria-label="الدعم الفني" @click="open = !open">
      <i class="fa" :class="open ? 'fa-times' : 'fa-headphones'"></i>
      <span v-if="!open" class="sf-fab-label">الدعم الفني</span>
    </button>
  </div>
</template>

<script>
import SupportBot from './SupportBot.vue';
import { WHATSAPP, urgentAccess } from './support-api';

// Floating «الدعم الفني» button on every signed-in dashboard page (it replaced the old AI assistant):
// the new assistant, «الدعم الفني السريع» and WhatsApp. Hidden on the contact and ticket pages,
// which show the same things in full.
var HIDDEN = ['/login', '/register', '/reset', '/logout', '/activate', '/error-404', '/system_stopped', '/expired', '/feedback', '/ticket/', '/_xteacher', '/autologin', '/reply-to-ghiab'];

export default {
  components: { SupportBot },
  data(){
    return { open: false, path: window.location.pathname, whatsapp: WHATSAPP, supportState: null };
  },
  computed: {
    visible(){
      if (!localStorage.getItem('user')) return false;
      var p = this.path;
      return !HIDDEN.some(function(h){ return p.indexOf(h) === 0; });
    },
  },
  watch: {
    $route(){
      this.path = window.location.pathname;
      this.open = false;
    },
    // asked when the panel opens: 'blocked' shows «تذكرة دعم فني» instead of «الدعم الفني السريع»
    open(v){
      var g = this;
      if (v) urgentAccess().then(function(a){ g.supportState = a.state; });
    },
  },
  methods: {
    go(to){
      this.open = false;
      this.$router.push(to).catch(function(){});
    },
    urgent(q){
      this.go('/feedback?open=' + (this.supportState == 'blocked' ? 'normal' : 'urgent') + (q ? '&q=' + encodeURIComponent(q) : ''));
    },
  },
};
</script>

<style scoped>
.sf { position: fixed; z-index: 1040; display: flex; flex-direction: column; align-items: flex-end; gap: 12px; }
.sf-fab {
  height: 52px; min-width: 52px; padding: 0 18px; border-radius: 26px; border: 0; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center; gap: 10px;
  background: var(--primary); color: #fff; font-weight: 700; box-shadow: 0 10px 24px rgba(29, 78, 216, 0.35);
}
.sf-fab .fa { font-size: 20px; }
.sf-fab-open { padding: 0; width: 52px; }
.sf-fab:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.45); outline-offset: 2px; }
.sf-panel {
  position: absolute; bottom: 64px; width: 380px; max-width: calc(100vw - 40px); height: min(600px, calc(100vh - 110px));
  margin: 0; padding: 14px; border-radius: 18px; box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);
  display: flex; flex-direction: column; gap: 10px;
}
.sf-head { display: flex; align-items: center; gap: 10px; }
.sf-head-icon { width: 40px; height: 40px; border-radius: 12px; background: linear-gradient(135deg, #4f46e5, #2563eb); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.sf-head-text { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.sf-head-text small { opacity: 0.7; }
.sf-x { border: 0; background: transparent; color: inherit; width: 34px; height: 34px; border-radius: 10px; cursor: pointer; opacity: 0.7; }
.sf-x:hover { background: rgba(127, 127, 127, 0.1); opacity: 1; }
.sf-links { display: flex; gap: 6px; flex-wrap: wrap; }
.sf-link {
  display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 600;
  border: 1px solid rgba(127, 127, 127, 0.25); background: transparent; color: inherit; cursor: pointer; text-decoration: none;
}
.sf-link:hover { background: rgba(127, 127, 127, 0.08); color: inherit; text-decoration: none; }
.sf-link-urgent { border-color: rgba(234, 84, 85, 0.4); color: #c62828; }
.sf-link-urgent:hover { color: #c62828; }
.sf-link-wa { border-color: rgba(22, 163, 74, 0.4); color: #15803d; }
.sf-link-wa:hover { color: #15803d; }
.sf-bot { flex: 1; min-height: 0; }
.sf-pop-enter-active, .sf-pop-leave-active { transition: opacity 0.16s ease, transform 0.16s ease; }
.sf-pop-enter, .sf-pop-leave-to { opacity: 0; transform: translateY(8px); }
@media (prefers-reduced-motion: reduce) { .sf-pop-enter-active, .sf-pop-leave-active { transition: none; } }
@media (max-width: 480px) {
  .sf-fab-label { display: none; }
  .sf-fab { padding: 0; width: 52px; }
}
@media print { .sf { display: none; } }
</style>
